<div *ngFor="let tag of tags" class="d-flex align-items-center">
  <sm-tag *ngIf="EXPERIMENTS_TAGS[tag]"
          [smTooltip]="EXPERIMENTS_TAGS_TOOLTIP[tag]"
          [label]="EXPERIMENTS_TAGS[tag]">
  </sm-tag>
</div>

